export default [
  {
    path: '/pages/pricing',
    name: 'pages-pricing',
    component: () => import('./Pricing.vue'),
    meta: {unused: true}
  },
]